import React from 'react';
import { BeaconSubtitleContainer } from 'src/components/BeaconV2Components/BeaconChartWithLegend/BeaconSubtitleContainer';
import BeaconComparableSplineChart from 'src/components/BeaconV2Components/BeaconMetricSplineChart/BeaconComparableSplineChart';
import { useCreateRemoveRetailPriceRangeFilters } from 'src/components/BeaconV2Components/ExperimentalLayout/Forecasts/serverProxy/useBaseMetricRequestBuilder';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import {
  useEntityPhrasing,
  useTaxonomySubtitleText
} from 'src/components/BeaconV2Components/common/BeaconProDynamicSubtitle/hooks';
import SubtitleFilters from 'src/components/Charts/SubtitleFilters';
import { useComparisonTimePeriodShortDisplayName, useMainTimePeriodShortDisplayName } from 'src/utils/Hooks';
import { BEACON_INDEX_NAMES } from 'src/utils/entityDefinitions/indexes/beaconIndexNames';

/**
 * Weekly Review Volume chart grouped by weekId.
 *
 */
const WeeklyReviewVolumeChart = () => {
  const comparisonTimePeriodShortDisplayName = useComparisonTimePeriodShortDisplayName();
  const mainTimePeriodShortDisplayName = useMainTimePeriodShortDisplayName();
  const entityPhrase = useEntityPhrasing();
  const taxonomyText = useTaxonomySubtitleText();
  const removeRetailPriceRangeFilters = useCreateRemoveRetailPriceRangeFilters();

  return (
    <BeaconComparableSplineChart
      beaconChartWithLegendOverride={(props) => {
        return {
          ...props,
          includeSummaryInfo: false,
          subtitle: (
            <BeaconSubtitleContainer>
              <Text variant="body1">
                {`The chart displays the review volume for ${entityPhrase} `}
                {taxonomyText}
                {` during the ${mainTimePeriodShortDisplayName} period compared to the ${comparisonTimePeriodShortDisplayName}.`}
                <SubtitleFilters />
              </Text>
            </BeaconSubtitleContainer>
          )
        };
      }}
      indexName={BEACON_INDEX_NAMES.RATINGS_REVIEWS_METRICS_V2}
      fieldName="weeklyReviewVolume"
      requestBuilder={removeRetailPriceRangeFilters()}
    />
  );
};

export default WeeklyReviewVolumeChart;
